module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.extras) ? _c('section', [_c('div', {
    staticClass: "extras container"
  }, _vm._l((_vm.extras), function(extra) {
    return _c('extra-module', {
      key: extra.slug,
      attrs: {
        "extra": extra
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "text-right container"
  }, [_c('router-link', {
    staticClass: "button button-underline",
    attrs: {
      "to": {
        name: 'Extras'
      }
    }
  }, [_vm._v("All Extras")])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7392c052"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/LatestExtras.vue
// module id = 792
// module chunks = 1